module.exports = __webpack_public_path__ + "img/404.069b5631.webp";